import {
	FileApiService,
	getFileGQL,
	onFileUpdateGQL,
	onPreflightProgressGQL,
	retryPreflightGQL,
	uploadFileGQL,
} from './file-api.service';

// Note that these have a dependency on Apollo from 'apollo-angular'.

export const fileApiProviders = [
	getFileGQL,
	retryPreflightGQL,
	onFileUpdateGQL,
	onPreflightProgressGQL,
	uploadFileGQL,
	FileApiService,
] as const;
